import React from 'react';
import './PetCard.css';

const PetCard = ({ pet, isFavorite, toggleFavorite, handleAdoptNow }) => {
  return (
    <div className="pet-card">
      <div className="pet-image-container">
        <img src={pet.image} alt={pet.name} className="pet-image" />
        <button
          className={`favorite-btn ${isFavorite ? 'active' : ''}`}
          onClick={() => toggleFavorite(pet.id)}
        >
          {isFavorite ? '❤️' : '🤍'}
        </button>
        <span className={`pet-tag ${pet.postedBy.toLowerCase()}`}>
          {pet.postedBy}
        </span>
      </div>

      <div className="pet-info">
        <h3 className="pet-name">{pet.breed} - {pet.name}</h3>
        
        <div className="pet-details">
          <span className="pet-detail">
            <span className="detail-icon">🎂</span>
            {pet.age}
          </span>
          <span className="pet-detail">
            <span className="detail-icon">{pet.gender === 'Male' ? '♂️' : '♀️'}</span>
            {pet.gender}
          </span>
        </div>

        <div className="pet-location">
          <span className="location-icon">📍</span>
          {pet.location}
        </div>

        <button 
          className="adopt-btn"
          onClick={() => handleAdoptNow(pet)}
        >
          Adopt Now
        </button>
      </div>
    </div>
  );
};

export default PetCard;
